import React, { useState, useEffect } from 'react';
import {
  Col,
  Container,
  Form,
  Spinner,
  Input,
  FormFeedback,
  ButtonGroup,
  Table,
  Button
} from 'reactstrap';
// Redux
import moment from 'moment';
import Switch from 'react-switch';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
// actions
import {
  getLabRequestSurveys,
  addNewLabRequestSurvey,
  updateLabRequestSurvey,
  getLabRequestCalculateSurveys
} from '../../../../store/labCitec/labRequestSurvey/actions';
import { getSurveyConcepts } from '../../../../store/catalogs/SurveyConcepts/actions';
import { getSurveyCategories } from '../../../../store/catalogs/SurveyCategories/actions';
import { toast } from 'react-toastify';
import { getApiCall, postApiCall } from '../../../../services/mainServices';

import { ConfirmationModal } from '../../../../components/Common/ConfirmationModal';
import { AnalysisRequestLastUpdate } from '../../../../components/Common/AnalysisRequestLastUpdate';
import {
  surveyStatus,
  Offsymbol,
  OnSymbol,
  surveyStatusFiltered,
  statuses,
  laboratoryOpinions
} from '../../../../constants';


// Formik validation
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { NotifyButton } from '../../Components';

export const LabCitecSurveyTab = ({ props, updateSurveyStatus, id, labRequest, advisers, activeTab, status, generalStatus }) => {

  const [showModal5, setShowModal5] = useState(false);
  let [mat, setMat] = useState([])
  let [opinionSelected, setOpinionSelected] = useState(laboratoryOpinions.NO_RESPONSES);

  let [surveyFlag, showSurveyFlag] = useState(true);

  let [alertConcepts, setAlertConcepts] = useState(false);
  let [alertMain, setAlertMain] = useState(false);

  // Canvas Hook
  const trackingStatus = labRequest?.labRequestTracking?.find(x => x.subStepTracking === 'Validación de encuesta')?.trackingStatus
  const role = (localStorage.getItem("authUser")) ? JSON.parse(localStorage.getItem("authUser"))?.role : ''
  let [hookCat, setHookCat] = useState([]);

  const booleanValidation = React.useMemo(
    () => generalStatus === statuses.FINISHED || generalStatus === statuses.CANCELLED,
    [generalStatus]
  );

  // * Redux
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getSurveyCategories("?limit=1000&page=0"))
    dispatch(getSurveyConcepts("?limit=1000&page=0"))
    dispatch(getLabRequestCalculateSurveys(`?labRequest=${id}`))
    setTimeout(() => {
      dispatch(getLabRequestSurveys(`?limit=20&page=0&labRequest=${id}`))
    }, 400);
  }, [activeTab])

  let { surveyConcepts, loading, surveyCategories, labRequestSurveys, calculate } = useSelector(state => ({
    surveyConcepts: state.surveyConceptsReducer.surveyConcepts,
    calculate: state.labRequestSurveyReducer.calculate,
    loading: state.labRequestSurveyReducer.loading,
    surveyConcept: state.surveyConceptsReducer.surveyConcept,
    total: state.surveyConceptsReducer.total,
    currentPage: state.surveyConceptsReducer.currentPage,
    labRequestSurveys: state.labRequestSurveyReducer.labRequestSurveys,
    surveyCategories: state.surveyCategoriesReducer.surveyCategories,
  }), shallowEqual);
  // * Redux fin

  useEffect(() => {
    const newMat = surveyConcepts.map((element, index) => ({
      id: element.id,
      ind: index,
      active: false,
      concept: element.concept,
      surveyCategory: element.surveyCategory,
    }));
    setMat(newMat);
    setHookCat(surveyCategories);
  }, [surveyConcepts, surveyCategories]);

  useEffect(() => {
    let categories = []
    const obj = labRequestSurveys[labRequestSurveys.length - 1]
    obj?.labRequestSurveyResponses?.forEach(element => {
      const cat = element?.surveyCategory
      categories.push(cat)
      const id1 = element?.concept
      const obj2 = mat.find(x => x.concept === id1)
      if (obj2) {
        mat.find(x => x.concept === id1).active = element.response
      }
      setMat(mat)
    });

    opinionSelected = labRequestSurveys[labRequestSurveys.length - 1]?.laboratoryOpinion ?? ''
    setOpinionSelected(opinionSelected)

    if(trackingStatus === 'Concluido'){
      categories = [...new Set(categories)]
      categories = categories.map((el)=> {
        return({
        name: el
      }
      )})
      setHookCat(categories)
    }
  }, [labRequestSurveys])

  const sendAutomatedSurveyNotification = async () => {
    try {
      const responsibles = [];

      // 1. Coordinador (Validador de informes)
      const coordinatorAssignment = labRequest?.labRequestAssignment?.find(
        x => x.statusAssignment?.toLowerCase() === 'validación de informes'
      );
      if (coordinatorAssignment?.user?.id) {
        responsibles.push(coordinatorAssignment.user.id);
      }

      // 2. Asesor Técnico (Creador de la solicitud)
      const techAdviserId = labRequest?.technicalAdviser?.id ?? labRequest?.createdBy?.id ?? labRequest?.user?.id;
      if (techAdviserId) {
        responsibles.push(techAdviserId);
      }

      let surveyRuleUserId = null;
      // 3. Responsable de Encuesta de satisfacción (Catálogo de asignaciones)
      try {
        const defaultAssignmentsRes = await getApiCall('default-assignments', {
          limit: 100,
          page: 0,
          recordStatus: 'enable',
        });
        const rules = Array.isArray(defaultAssignmentsRes?.data?.items)
          ? defaultAssignmentsRes.data.items
          : Array.isArray(defaultAssignmentsRes?.items)
          ? defaultAssignmentsRes.items
          : Array.isArray(defaultAssignmentsRes?.data)
          ? defaultAssignmentsRes.data
          : Array.isArray(defaultAssignmentsRes)
          ? defaultAssignmentsRes
          : [];

        const reqLabTypeId = (
          labRequest?.laboratoryArea?.laboratoryType?.id ||
          labRequest?.laboratoryType?.id ||
          labRequest?.laboratory?.id
        )?.toLowerCase();

        const matchedSurveyRules = rules.filter(rule => {
          const isSurveyType = (rule.assignmentType || '').toLowerCase().trim().includes('satisfac');
          if (!isSurveyType) return false;

          const ruleLabTypeId = rule.laboratoryType?.id?.toLowerCase();
          return !reqLabTypeId || !ruleLabTypeId || reqLabTypeId === ruleLabTypeId;
        });

        matchedSurveyRules.forEach(rule => {
          if (rule.user?.id) {
            responsibles.push(rule.user.id);
          }
        });
      } catch (err) {
        console.error('Error al consultar asignaciones por defecto:', err);
      }

      // IDs únicos de destinatarios solicitados (Coordinador, Asesor Técnico y Responsable de Encuesta)
      const uniqueResponsibles = [...new Set(responsibles)].filter(Boolean);

      if (uniqueResponsibles.length > 0) {
        const currentUser = localStorage.getItem('authUser') ? JSON.parse(localStorage.getItem('authUser')) : null;
        const notificationPayload = {
          datedAt: moment().format('YYYY-MM-DD'),
          validateProcess: 'Encuesta de satisfacción',
          validationStatus: 'Solicitud de revisión',
          description: 'Hemos habilitado la encuesta de satisfacción del servicio entregado y solicitamos unos minutos de tu tiempo para evaluar nuestros servicios. Apreciamos cualquier comentario de mejora o queja que puedas tener. IMPORTANTE: La encuesta está prellenada con la calificación más alta de "5", pero por favor ajusta el puntaje de calificación según tu experiencia real. Tu opinión es muy valiosa para nosotros y nos ayuda a mejorar. ¡Agradecemos tu colaboración y esperamos recibir tu feedback!',
          labRequest: id,
          userNotifier: currentUser?.id,
          notificationResponsibles: uniqueResponsibles,
        };

        await postApiCall('notification-managers', notificationPayload);
        toast.success('Notificación de encuesta enviada automáticamente');
      }
    } catch (error) {
      console.error('Error al enviar la notificación automática:', error);
    }
  };

  const validation2 = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: (labRequest?.labRequestTracking?.find(x => x.subStepTracking === 'Validación de encuesta')?.id),
      trackingStatus: (trackingStatus) ?? ''
    },
    validationSchema: Yup.object({
      trackingStatus: Yup.string().required("El estatus es un campo obligatorio"),
    }),
    onSubmit: (values, { resetForm }) => {
      if (values.trackingStatus === 'Encuesta Realizada') {
        let unselected = false;
        mat.forEach(element => {
          if (!element.active) unselected = true;
        });

        if (unselected) {
          toast.error('Debe calificar todos los conceptos de la encuesta');
          return;
        }

        const opportunitiesText = validation1.values.descriptionOpportunities;
        if (!opportunitiesText || !opportunitiesText.trim()) {
          validation1.setFieldTouched('descriptionOpportunities', true, true);
          toast.error('Debe ingresar las oportunidades de mejora antes de guardar la encuesta realizada');
          return;
        }
      }

      if (values.trackingStatus === 'Solicitud de Encuesta') {
        mat.forEach(element => {
          element.active = 5;
        });
        setMat([...mat]);
        sendAutomatedSurveyNotification();
      }

      // 1. PRIMERO: Guardar las respuestas de la encuesta (botón inferior eliminado)
      validation1.submitForm();

      // 2. DESPUÉS: Actualizar el estatus de la encuesta (botón superior)
      updateSurveyStatus(values);
  
      // Set automatic dates
      if (values.trackingStatus === 'Solicitud de Encuesta') {
        const sendedDate = moment().format('YYYY-MM-DD');
        validation1.setFieldValue('sendedAt', sendedDate);
      }
  
      if (values.trackingStatus === 'Encuesta Realizada') {
        const performedDate = moment().format('YYYY-MM-DD');
        validation1.setFieldValue('performedAt', performedDate);
      }
  
      if (labRequestSurveys[0]?.id) {
        if (values.trackingStatus === 'Solicitud de Encuesta') {
          dispatch(updateLabRequestSurvey({
            id: labRequestSurveys[0]?.id,
            sendedAt: moment().format('YYYY-MM-DD')
          }))
        } else if (values.trackingStatus === 'Encuesta Realizada') {
          dispatch(updateLabRequestSurvey({
            id: labRequestSurveys[labRequestSurveys.length - 1]?.id,
            performedAt: moment().format('YYYY-MM-DD')
          }))
        }
      }
    }
  });

  const lastSurvey = labRequestSurveys?.[labRequestSurveys.length - 1];
  const validation1 = useFormik({
    enableReinitialize: true,
    initialValues: {
    labRequest: labRequest?.id,
    descriptionOpportunities: lastSurvey?.descriptionOpportunities ?? '',
    complaintDescription: lastSurvey?.complaintDescription ?? '',
    additionalComment: lastSurvey?.additionalComment ?? '',
    sendedAt: lastSurvey?.sendedAt ? moment.utc(lastSurvey?.sendedAt).format('YYYY-MM-DD') : '',
    performedAt: lastSurvey?.performedAt ? moment.utc(lastSurvey?.performedAt).format('YYYY-MM-DD') : '',
    hasComplaint: lastSurvey?.hasComplaint ?? false,
    hasAdditionalComment: lastSurvey?.hasAdditionalComment ?? false,
  },
    validationSchema: Yup.object({
      descriptionOpportunities: Yup.string().test(
        'isRequired',
        'Las oportunidades de mejora es un campo obligatorio',
        function (value) {
          if (validation2.values.trackingStatus === 'Encuesta Realizada') {
            return !!value && value.trim().length > 0;
          }
          return true;
        }
      ),
    }),
    onSubmit: (values, { resetForm }) => {
      const arr = []
      mat.forEach(element => {
        if(element.active !== false){
          arr.push({
            concept: element.concept,
            surveyCategory: element.surveyCategory.name,
            response: + element.active,
          })
        }
      });
      const upd = {
        ...values,
        laboratoryOpinion: laboratoryOpinions.NO_RESPONSES,
        responses: arr,
        complaintDescription: (!values.hasComplaint) ? '' : values.complaintDescription,
        additionalComment: (!values.additionalComment) ? '' : values.additionalComment
      }
      dispatch(addNewLabRequestSurvey(upd))

      setTimeout(() => {
        dispatch(getLabRequestCalculateSurveys(`?labRequest=${id}`))
      }, 800)
    }
  });

  const onAcceptStatus = () => {
    validation2.submitForm()
  }

  const onAccept = () => {
    alertConcepts = false
    setAlertConcepts(alertConcepts)
    mat.forEach(element => {
      if (element.active === false) {
        alertConcepts = true
        setAlertConcepts(alertConcepts)
      }
    });
    if (opinionSelected === '') {
      alertMain = true
      setAlertMain(alertMain)
    } else {
      alertMain = false
      setAlertMain(alertMain)
    }
    validation1.submitForm()
  }

  return (
    <div className="d-flex justify-content-center">
      <Container fluid className="" >
        <Col className="col-12" style={{ padding: 20 }}>
          <Form
            className="form-horizontal mt-2 mb-1"
            onSubmit={(e) => {
              e.preventDefault();
              validation2.handleSubmit();
              return false;
            }}
          >
            <ConfirmationModal onAccept={onAcceptStatus} showModal={showModal5} setShowModal={setShowModal5} message='¿Estás seguro de cambiar el estatus de la sección de Encuesta de Satisfacción?' />
            {/* <ConfirmationModal onAccept={onAccept} showModal={showModal7} setShowModal={setShowModal7} message='¿Estás seguro de cambiar el estatus de la sección de Encuesta de Satisfacción?' /> */}
            <div className="page-title-box d-flex align-items-center justify-content-start">
              <AnalysisRequestLastUpdate client={`${labRequest?.labRequestTracking?.find(x => x.subStepTracking === 'Validación de encuesta')?.updatedBy?.name ?? ''} ${labRequest?.labRequestTracking?.find(x => x.subStepTracking === 'Validación de encuesta')?.updatedBy?.surname ?? ''}`}
                date={`${moment(labRequest?.labRequestTracking?.find(x => x.subStepTracking === 'Validación de encuesta')?.updatedAt).format('YYYY-MM-DD HH:mm') ?? ''}`} />

              <div className='d-flex align-items-end justify-content-end pt-3 w-50'>
                <div className="mx-1" >
                  <label className='text-primary ml-1'>Estatus</label>
                  {
                    (role !== 'Asesor Técnico') ?
                    <select
                      disabled={(role === 'Laboratorista') || (trackingStatus === 'Encuesta Realizada') || (generalStatus === 'Concluida' || generalStatus === 'Cancelada')}
                      name="trackingStatus"
                      className="form-select text-primary rounded-3"
                      onChange={(e) => {
                        validation2.handleChange(e);
                        if (e.target.value === 'Solicitud de Encuesta') {
                          mat.forEach(element => {
                            element.active = 5;
                          });
                          setMat([...mat]);
                        }
                      }}
                      onBlur={validation2.handleBlur}
                      value={validation2.values.trackingStatus || ""}
                    >
                      {
                        (trackingStatus !== 'Pendiente') ?
                      surveyStatus.map((dir, index) => {
                        return <option key={index} value={dir.id}>{dir.value}</option>
                      }) : surveyStatusFiltered.map((dir, index) => {
                        return <option key={index} value={dir.id}>{dir.value}</option>
                      })
                      }
                    </select> :

                  <select
                    disabled={(role === 'Laboratorista') || (trackingStatus === 'Encuesta Realizada') || (generalStatus === 'Concluida' || generalStatus === 'Cancelada')}
                    name="trackingStatus"
                    className="form-select text-primary rounded-3"
                    onChange={(e) => {
                      validation2.handleChange(e);
                      if (e.target.value === 'Solicitud de Encuesta') {
                        mat.forEach(element => {
                          element.active = 5;
                        });
                        setMat([...mat]);
                      }
                    }}
                    onBlur={validation2.handleBlur}
                    value={validation2.values.trackingStatus || ""}
                  >
                      <option key={1} value={validation2.values.trackingStatus}>{validation2.values.trackingStatus}</option>
                      <option key={2} value={'Encuesta Realizada'}>{'Encuesta Realizada'}</option>
                  </select>
                  }
                </div>

                <div className='mx-1'>
                  <NotifyButton
                    pathName={`/process-notification/${id}`}
                    booleanValidation={booleanValidation}
                  ></NotifyButton>
                </div>
                <div className='mx-1'>
                  <label className='text-primary ml-1'></label>
                  <button disabled={(role === 'Asesor Técnico' && trackingStatus === 'Pendiente') || (role === 'Laboratorista') || (trackingStatus === 'Encuesta Realizada') || (generalStatus === 'Concluida' || generalStatus === 'Cancelada')} type='button' onClick={() => { setShowModal5(true) }} className="btn btn-success py-2 w-100 rounded-3" >
                    <span className="mdi mdi-content-save me-2"></span>Guardar
                  </button>
                </div>
              </div>

            </div>
          </Form>

          {
            loading ?
              <div className="text-center py-5">
                <Spinner
                  color="primary"
                >
                </Spinner>
                <div className="row-center mt-2">
                  {' '}Cargando...
                </div>
              </div> :
              <div>
                <div className='row mt-3'>
                  <hr className='text-primary' />
                  <h5 className='text-info'> Encuestas de Satisfacción  </h5>
                  <div className='mt-4 d-flex justify-content-middle'>
                    <div className='col-9 col-md-9 px-5'>
                      <div className="row justify-content-center">
                        {
                          surveyFlag ?
                          <ButtonGroup >
                            <Button
                              outline
                              color='danger'
                              onClick={() => {

                              }
                              }
                              active={true}
                            >
                              <div className='px-5'>1</div>
                              <div className='px-5'>Malo</div>
                            </Button>
                            <Button
                              outline
                              color='warning1'
                              // style={{maxWidth:'15%'}}
                              onClick={() => {

                              }}
                              active={true}
                            >
                              <div className='px-5'>2</div>
                              <div className='px-5'>Regular</div>
                            </Button>

                            <Button
                              outline
                              color='warning'
                              // style={{maxWidth:'15%'}}
                              onClick={() => {
                              }}
                              active={true}
                            >
                              <div className='px-5'>3</div>
                              <div className='px-5'>Bueno</div>
                            </Button>

                            <Button
                              color='success'
                              // style={{maxWidth:'15%'}}
                              outline
                              onClick={() => {

                              }}
                              active={true}
                            >
                              <div className='px-5'>4</div>
                              <div className='px-5'>Muy Bueno</div>
                            </Button>

                            <Button
                              color='success1'
                              // style={{maxWidth:'15%'}}
                              outline
                              onClick={() => {
                              }}
                              active={true}
                            >
                              <div className='px-5'>5</div>
                              <div className='px-5'>Excelente</div>
                            </Button>
                          </ButtonGroup> : null
                        }
                      </div>
                    </div>
                    <div className='col-3 col-md-3'>
                      <div className='text-center'>
                        <div>
                        <label>Mostrar indicador</label>
                        </div>
                        <Switch
                              uncheckedIcon={<Offsymbol />}
                              checkedIcon={<OnSymbol />}
                              onColor="#94C12E"
                              onChange={() => { showSurveyFlag(!surveyFlag) }}
                              checked={surveyFlag}
                          />
                      </div>
                    </div>

                  </div>
                  {/* Botón Guardar inferior eliminado por requerimiento de optimización de flujo */}
                </div>

                {
                  hookCat.map(
                    (categorie, rowIndex) => {
                      return (
                        <React.Fragment key={categorie.id || rowIndex}>
                          <div className='d-flex justify-content-center'>
                            {/* <div className='row'> */}
                              <div className='text-center col-9 col-md-12'>
                                <h5 className='text-primary'>{categorie?.name ?? '-'}</h5>
                                <Table className='table-responsive' bordered striped responsive /*style={{width:'50%'}}*/>
                                  <thead>
                                    <tr>
                                      <th width="40%">
                                        Concepto
                                      </th>
                                      <th width="60%">
                                        Respuesta
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {
                                      surveyConcepts.map(
                                        (concepts, index) => {
                                          return (
                                            <React.Fragment key={concepts.id || index}>
                                              {
                                                (concepts?.surveyCategory.name === categorie.name) ?
                                                  <tr>
                                                    <th scope='row' className='text-center' >
                                                      {
                                                        concepts?.concept ?? ''
                                                      }
                                                    </th>
                                                    <td>
                                                      <ButtonGroup key={index + 1} id={index}>
                                                        <Button
                                                          outline
                                                          color='danger'
                                                          onClick={() => {
                                                            const obj = mat?.find(x => x.ind === index)
                                                            if (obj) {
                                                              obj.active = 1
                                                            }
                                                            setMat(mat)
                                                          }
                                                          }
                                                          active={mat?.find(x => x.ind === index)?.active === 1}
                                                        >
                                                          <div className='px-5'>1</div>
                                                        </Button>
                                                        <Button
                                                          outline
                                                          color='warning1'
                                                          onClick={() => {
                                                            const obj = mat?.find(x => x.ind === index)
                                                            if (obj) {
                                                              obj.active = 2
                                                            }
                                                            setMat(mat)
                                                          }}
                                                          active={mat?.find(x => x.ind === index)?.active === 2}
                                                        >
                                                          <div className='px-5'>2</div>
                                                        </Button>

                                                        <Button
                                                          outline
                                                          color='warning'
                                                          onClick={() => {
                                                            const obj = mat?.find(x => x.ind === index)
                                                            if (obj) {
                                                              obj.active = 3
                                                            }
                                                            setMat(mat)
                                                          }}
                                                          active={mat?.find(x => x.ind === index)?.active === 3}
                                                        >
                                                          <div className='px-5'>3</div>
                                                        </Button>

                                                        <Button
                                                          color='success'
                                                          outline
                                                          onClick={() => {
                                                            const obj = mat?.find(x => x.ind === index)
                                                            if (obj) {
                                                              obj.active = 4
                                                            }
                                                            setMat(mat)
                                                          }}
                                                          active={mat?.find(x => x.ind === index)?.active === 4}
                                                        >
                                                          <div className='px-5'>4</div>
                                                        </Button>

                                                        <Button
                                                          color='success1'
                                                          outline
                                                          onClick={() => {
                                                            const obj = mat?.find(x => x.ind === index)
                                                            if (obj) {
                                                              obj.active = 5
                                                            }
                                                            setMat(mat)
                                                          }}
                                                          active={mat?.find(x => x.ind === index)?.active === 5}
                                                        >
                                                          <div className='px-5'>5</div>
                                                        </Button>
                                                      </ButtonGroup>
                                                    </td>
                                                  </tr> : null
                                              }

                                            </React.Fragment>

                                          )

                                        }
                                      )
                                    }
                                  </tbody>
                                </Table>
                              </div>
                          </div>
                        </React.Fragment>
                      )
                    }
                  )

                }


                {
                  <div className='row mt-3'>
                    <h5 className='text-primary text-center'> Resultados de Encuesta </h5>
                    <div className='d-flex justify-content-center'>
                      <div className='text-center col-3 col-md-8'>
                        <Table className='table-responsive' bordered striped>
                          <thead>
                            <tr>
                              {
                                calculate?.map(
                                  (element, index) => {
                                    return (
                                      <th key={element?.labRequestSurveyResponses_surveyCategory || index} width="20%">
                                        {element?.labRequestSurveyResponses_surveyCategory ?? '-'}
                                      </th>
                                    )
                                  }
                                )
                              }
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              {
                                calculate?.map(
                                  (element, index) => {
                                    return (
                                      <th key={element?.labRequestSurveyResponses_surveyCategory || index} width="20%">
                                        {element?.sum ?? '-'}
                                      </th>
                                    )
                                  }
                                )
                              }
                            </tr>
                          </tbody>
                        </Table>
                      </div>
                    </div>

                  </div>
                }

                <div className='row mt-3'>
                  <hr className='text-primary' />
                  <Form
                    className="form-horizontal mt-2 mb-1"
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation1.handleSubmit();
                      return false;
                    }}
                  >
                    <div className='row mt-2'>
                      <div className="mb-1 px-2">
                        <label className='text-primary'>¿Qué oportunidades de mejora nos sugieren?</label>
                        <Input
                          disabled={(role === 'Laboratorista' || trackingStatus === 'Bloqueado' || trackingStatus === 'Encuesta Realizada')}
                          required
                          name="descriptionOpportunities"
                          className="form-control rounded-3 text-primary"
                          type='textarea'
                          value={validation1.values.descriptionOpportunities}
                          onChange={validation1.handleChange}
                          onBlur={validation1.handleBlur}
                          invalid={
                            !!(validation1.touched.descriptionOpportunities && validation1.errors.descriptionOpportunities)
                          }
                        />
                        {validation1.touched.descriptionOpportunities && validation1.errors.descriptionOpportunities ? (
                          <FormFeedback type="invalid">{validation1.errors.descriptionOpportunities}</FormFeedback>
                        ) : null}
                      </div>
                    </div>

                    <div className='row mt-2'>
                      <div className="mb-1 px-2">
                        <label className='text-primary mr-3'>¿Tiene usted alguna queja del servicio recibido?</label>
                        <Switch
                            className='ml-3'
                            uncheckedIcon={<Offsymbol />}
                            checkedIcon={<OnSymbol />}
                            onColor="#94C12E"
                            onChange={(e) => {
                              validation1.setFieldValue('hasComplaint', e)
                            }}
                            checked={validation1.values.hasComplaint}
                        />
                        {
                          validation1.values.hasComplaint ?
                          <Input
                          // required
                          name="complaintDescription"
                          className="form-control rounded-3 text-primary"
                          type='textarea'
                          value={validation1.values.complaintDescription}
                          onChange={validation1.handleChange}
                          onBlur={validation1.handleBlur}
                          invalid={
                            !!(validation1.touched.complaintDescription && validation1.errors.complaintDescription)
                          }
                        />  : null
                        }

                      </div>
                    </div>

                    <div className='row mt-2'>
                      <div className="mb-1 px-2">
                        <label className='text-primary mr-3'>¿Tiene usted algún comentario adicional del servicio recibido?</label>
                        <Switch
                            className='ml-3'
                            uncheckedIcon={<Offsymbol />}
                            checkedIcon={<OnSymbol />}
                            onColor="#94C12E"
                            onChange={(e) => {
                              validation1.setFieldValue('hasAdditionalComment', e)

                            }}
                            checked={validation1.values.hasAdditionalComment}
                        />
                        {
                          validation1.values.hasAdditionalComment ?
                          <Input
                          name="additionalComment"
                          className="form-control rounded-3 text-primary"
                          type='textarea'
                          value={validation1.values.additionalComment}
                          onChange={validation1.handleChange}
                          onBlur={validation1.handleBlur}
                          invalid={
                            !!(validation1.touched.additionalComment && validation1.errors.additionalComment)
                          }
                        /> : null
                        }

                      </div>
                    </div>

                    <div className='row'>
                      <div className='d-flex justify-content-center mb-4'>
                        <div className='text-center col-3 col-md-6 me-2'>
                          <label className='text-primary'>Fecha Envío</label>
                          <Input
                            disabled
                            type='date'
                            name="sendedAt"
                            onBlur={validation1.handleBlur}
                            value={validation1.values.sendedAt}
                            onChange={validation1.handleChange}
                            className="form-control rounded-3 text-primary"
                          />
                        </div>

                        <div className='text-center col-3 col-md-6 me-2'>
                          <label className='text-primary'>Fecha de Realizada</label>
                          <Input
                            disabled
                            type='date'
                            name="performedAt"
                            onBlur={validation1.handleBlur}
                            onChange={validation1.handleChange}
                            value={validation1.values.performedAt}
                            className="form-control rounded-3 text-primary"
                          />
                        </div>
                      </div>
                    </div>
                  </Form>

                </div>
              </div>
          }
          <br />

        </Col>
      </Container>

    </div>
  )
}
